import { render, staticRenderFns } from "./CallBackModal.vue?vue&type=template&id=4b0e9b83&"
import script from "./CallBackModal.vue?vue&type=script&lang=js&"
export * from "./CallBackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports